import './App.css';
import logo2 from './app-icon.png';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo2} className="App-logo" alt="logo" />
        <p>
        <h3><div>Para suporte, dúvidas e sugestões entre em contato conosco:</div></h3>
          <div>Telefone: (48) 98849-0075</div> 
          <div>Email: julio@versatileprohuman.com</div>
          <div>Endereço: Alameda Arpo, 333, Sala 1, Ouro Fino</div>
          <div>São José dos Pinhais, Paraná, 83010-290</div>
        </p>
      </header>
    </div>
  );
}

export default App;